import clsx from 'clsx';
import { ReactNode } from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  fill?: 'primary' | 'secondary' | 'dark';
  variant?: 'solid' | 'outline';
  rounded?: boolean;
  name?: string;
  loading?: boolean;
}
export const Button = ({
  children,
  className,
  disabled,
  loading,
  ...props
}: ButtonProps) => {
  return (
    <button
      {...props}
      className={clsx(
        'flex justify-center rounded-md p-2 font-medium',
        className,
        disabled && 'opacity-50'
      )}
      disabled={disabled}
    >
      {loading ? (
        <>
          <AiOutlineLoading3Quarters className="my-auto mr-3 animate-spin text-xl" />
          {children}
        </>
      ) : (
        children
      )}
    </button>
  );
};

interface MessageCardProps {
  text: ReactNode;
  title?: string;
  className?: string;
}

export const MessageCard = ({ text, title, className }: MessageCardProps) => {
  return (
    <div className={clsx('rounded-md border p-3', className)}>
      {title && <p className="mb-3 text-lg font-medium">{title}</p>}
      {text}
    </div>
  );
};
